// extracted by mini-css-extract-plugin
module.exports = {"root":"Bar-root-77adf4291f7df8392a742a526ddbca0b"};